import {combineReducers} from "redux";
import MovieBookingReducer from "./MovieReducer";

const rootReducer = combineReducers({
    MovieBookingReducer,
})

export default rootReducer;